import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.css'

class SubOrderGroup extends React.PureComponent {

  static propTypes = {
    subOrderGroup: PropTypes.object.isRequired,
    subOrder: PropTypes.object,
  }

  render() {

    const {
      subOrderGroup,
      subOrder,
    } = this.props

    const hasSetPercentage = subOrder && subOrder.set_percentage !== null && subOrder.set_percentage !== undefined

    return (

      <div className={styles.wrapper}>

        <input
          value={subOrderGroup.name || ''}
          placeholder='Untitled Group'
          readOnly
          className={styles.name}
        />

        <div className={styles.headings}>

          <div className={styles.cell}>
            Qty
          </div>

          <div className={styles.cell}>
            Unit
          </div>

          <div className={styles.cell}>
            Rate
          </div>

          {hasSetPercentage && (
            <div className={styles.cell} style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>
              Subcontractor Total
            </div>
          )}

          <div className={styles.cell}>
            Company Total
          </div>

          <div className={styles.cell}>
            Prev
          </div>

          <div className={styles.cell}>
            New
          </div>

          <div className={styles.cell}>
            Diff
          </div>

        </div>

      </div>

    )

  }

}

export default SubOrderGroup
